import React, { useState } from 'react';
import {
	Button,
	Dialog,
	DialogTitle,
	TextField,
	Theme,
	DialogContent,
	DialogActions,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Spinner from './Spinner';
import { useTranslation } from 'services/localization/useTranslation';
import { isValidEmail } from 'common/utils/validation';

interface Props {
	open: boolean;
	email: string;
	isSending: boolean;
	onSubmit: (email: string) => void;
	onClose: () => void;
}

const SendEmailDialog = (props: Props) => {
	const { open, email, isSending, onSubmit, onClose } = props;
	const { t } = useTranslation();
	const classes = useStyles();

	const [editedEmail, setEditedEmail] = useState(email);
	const [invalidEmail, setInvalidEmail] = useState(false);

	const handleSubmit = () => {
		if (!isValidEmail(editedEmail)) {
			setInvalidEmail(true);
			return;
		}
		onSubmit(editedEmail);
	};

	return (
		<Dialog onClose={onClose} open={open} fullWidth maxWidth={'xs'}>
			<DialogTitle className={classes.padding}>
				{t('sendBookingConfirmation2', 'Send order confirmation')}
			</DialogTitle>
			<DialogContent>
				<TextField
					variant="standard"
					label={t('common:form.email')}
					name="email"
					type="email"
					value={editedEmail}
					onChange={(e) => {
						setEditedEmail(e.target.value);
						setInvalidEmail(false);
					}}
					fullWidth
					error={invalidEmail}
					helperText={invalidEmail ? t('common:validation.isNotValidEmail') : ''}
				/>
			</DialogContent>
			<DialogActions className={classes.padding}>
				<Button variant="text" color="secondary" onClick={onClose}>
					{t('common:actions.cancel')}
				</Button>
				<Button variant="contained" color="primary" onClick={handleSubmit} disabled={isSending}>
					{isSending ? <Spinner relative size={24} color="inherit" /> : t('common:actions.send')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		padding: {
			padding: theme.spacing(3),
		},
	}),
);

export default SendEmailDialog;
